export const ca: Record<string, string> = {
  'nav.leagues_load_failed': 'No s’han pogut carregar les teves lligues. Torna a obrir el menú per reintentar-ho.',
  'api.calls_count': '{count} trucades registrades',
  'api.clear': 'Netejar registre de trucades',
  'api.filter_method': 'Mètode:',
  'api.latency': 'Latència: {ms} ms',
  'api.latency_hint': 'Latència simulada mitjana: ~180ms · HTTP/2',
  'api.no_calls': 'No hi ha trucades registrades encara. Fes qualsevol acció al joc.',
  'api.payload': 'Payload de la Petició (Request Body):',
  'api.response': 'Resposta del Servidor (Mocked Response):',
  'api.select_hint': 'Fes clic en qualsevol petició de la llista per veure el seu payload i resposta mockejada en format JSON.',
  'api.status_ok': 'Estat: {status} OK',
  'api.subtitle': 'Registre en temps real de trucades simulades a la capa de serveis',
  'api.time': 'Hora: {time}',
  'api.title': 'Consola d’Endpoints REST (Mock Responses)',
  'auth.authenticating': 'Autenticant al servidor...',
  'auth.demo_hint': 'Fes clic a l’accés ràpid per entrar com a Mànager Oficial amb dades precarregades.',
  'auth.email': 'Correu Electrònic',
  'auth.enter_credentials': 'Introdueix les teves credencials per accedir a la gestió del teu club.',
  'auth.err_email_required': 'L’usuari o correu és obligatori',
  'auth.err_password_required': 'La contrasenya és obligatòria',
  'auth.feat_finance': 'Estadi, mòdul comercial, préstecs i llibre major comptable',
  'auth.feat_market': 'Mercat de fitxatges, clàusules i negociació objectiva',
  'auth.feat_squad': 'Gestió de plantilla, tàctiques i planter',
  'auth.password': 'Contrasenya',
  'auth.password_required': 'La contrasenya és obligatòria',
  'auth.quick_access': 'Accés de Prova Ràpid (1 Clic)',
  'auth.remember_me': 'Recordar sessió',
  'auth.submit': 'Accedir a l’Oficina del Mànager',
  'auth.subtitle': 'Simulador de gestió esportiva professional amb motor de partits, economia i mercat en viu.',
  'auth.user_placeholder': 'usuari@exemple.cat o el teu usuari',
  'auth.user_required': 'L\'usuari o correu és obligatori',
  'auth.welcome': 'Benvingut a League of Managers',
  'auth.google_continue': 'Continuar amb Google',
  'auth.google_checking': 'Comprovant la teva sessió…',
  'auth.google_err_cancelled': 'Has cancel·lat l’accés amb Google.',
  'auth.google_err_expired': 'L’intent ha caducat o ja s’ha utilitzat. Torna-ho a provar.',
  'auth.google_err_not_allowed': 'Aquest compte no està habilitat per a la prova amb Google.',
  'auth.google_err_unavailable': 'No s’ha pogut iniciar sessió. Torna-ho a provar.',
  'auth.google_back_to_login': 'Tornar a l’inici de sessió',
  'auth.register_title': 'Crear Compte de Mànager',
  'auth.register_subtitle': 'Registra’t per dirigir el teu club i competir a League of Managers.',
  'auth.register_btn': 'Crear compte',
  'auth.register_creating': 'Creant compte…',
  'auth.repeat_password': 'Confirmar Contrasenya',
  'auth.repeat_password_required': 'Has de repetir la contrasenya',
  'auth.passwords_must_match': 'Les contrasenyes no coincideixen',
  'auth.password_min_length': 'La contrasenya ha de tenir almenys 8 caràcters',
  'auth.password_max_length': 'La contrasenya no pot superar 128 caràcters',
  'auth.email_invalid': 'Introdueix un correu electrònic vàlid',
  'auth.email_max_length': 'El correu no pot superar els 254 caràcters',
  'auth.register_success_title': 'Comprova el teu correu',
  'auth.register_success_neutral_msg': 'Si procedeix el registre, rebràs un correu per confirmar el teu compte; si ja en tens, fes servir el teu mètode d’accés habitual.',
  'auth.resend_btn': 'Reenviar correu de confirmació',
  'auth.resend_wait': 'Reenviar en {seconds}s',
  'auth.resend_sending': 'Reenviant…',
  'auth.resend_sent': 'Si el compte està pendent de confirmació, hem reenviat el correu.',
  'auth.has_account': 'Ja tens compte? Inicia sessió',
  'auth.no_account': 'No tens compte? Registra’t',
  'auth.err_email_not_verified': 'El teu correu electrònic encara no ha estat confirmat. Revisa la teva bústia d’entrada o sol·licita un nou enllaç.',
  'auth.err_invalid_request': 'Revisa les dades introduïdes. La contrasenya ha de tenir entre 8 i 128 caràcters.',
  'auth.err_rate_limited': 'Has realitzat massa sol·licituds. Espera un moment abans de tornar-ho a provar.',
  'auth.err_unavailable': 'El servei no està disponible temporalment. Torna-ho a provar més tard.',
  'auth.err_registration_disabled': 'El registre de comptes no està disponible en aquest moment.',
  'auth.verify_title': 'Confirmació de Correu Electrònic',
  'auth.verify_subtitle': 'Prem el botó per activar el teu compte de mànager a League of Managers.',
  'auth.verify_btn': 'Confirmar correu',
  'auth.verify_confirming': 'Confirmant el teu correu…',
  'auth.verify_success_title': 'Correu confirmat amb èxit!',
  'auth.verify_success_desc': 'El teu compte ja està actiu. Ja pots iniciar sessió amb el teu correu i contrasenya.',
  'auth.verify_go_to_login': 'Anar a Iniciar Sessió',
  'auth.verify_err_invalid_token': 'L’enllaç de confirmació és invàlid, ha caducat o ja s’ha utilitzat.',
  'auth.verify_err_resend_title': 'Necessites un nou enllaç?',
  'auth.verify_err_resend_desc': 'Introdueix el teu correu per rebre un nou enllaç d’activació.',
  'auth.verify_enter_email': 'Introdueix el teu correu electrònic',
  'auth.verify_request_new_link': 'Sol·licitar nou enllaç',
  'auth.verify_missing_token': 'No s’ha proporcionat cap testimoni de confirmació a l’enllaç.',
  'club.accounting_version': 'Versió comptable',
  'club.active_loans': 'activa(es)',
  'club.available_balance': 'Saldo Disponible en Caixa',
  'club.currency': 'Moneda',
  'club.healthy_accounts': 'Comptes Sanejats',
  'club.ledger_col_amount': 'Import',
  'club.ledger_col_balance': 'Saldo Resultant',
  'club.ledger_col_concept': 'Concepte',
  'club.ledger_col_date': 'Data',
  'club.ledger_col_origin': 'Origen',
  'club.ledger_col_type': 'Tipus',
  'club.ledger_desc': 'Registre comptable',
  'club.ledger_entries': 'apunts registrats',
  'club.ledger_expense': 'DESPESA',
  'club.ledger_income': 'INGRÉS',
  'club.ledger_title': 'Transaccions',
  'club.modules_synced': 'Mòduls comercials i d\'explotació sincronitzats',
  'club.no_ledger_entries': 'No hi ha apunts comptables registrats al llibre major.',
  'club.reserved_balance': 'Garanties / Fons Compromesos',
  'club.solvency_desc': 'Control patrimonial oficial de l\'entitat. Les finances del club es liquiden estrictament en euros (€).',
  'club.solvency_title': 'Estat de Solvència i Liquiditat',
  'club.total_balance': 'Balanç Total Auditat',
  'club.treasury_audited': 'Tresoreria auditada en temps real',
  'common.all': 'Tots',
  'common.back': 'Tornar',
  'common.cancel': 'Cancel·lar',
  'common.close': 'Tancar',
  'common.confirm': 'Confirmar',
  'common.delete': 'Eliminar',
  'common.edit': 'Modificar',
  'common.live': 'En directe',
  'common.loading': 'Carregant...',
  'common.retry': 'Reintentar',
  'common.save': 'Desar',
  'common.today': 'Avui',
  'common.version': 'Versió',
  'common.yesterday': 'Ahir',
  'comp.advance_round': 'Avançar a Jornada {round}',
  'comp.badge': 'Primera Divisió',
  'comp.box_office': 'Recaptació Taquilla',
  'comp.calendar_title': 'Calendari de Partits',
  'comp.close': 'Tancar',
  'comp.club_col': 'Club',
  'comp.col_club': 'Club',
  'comp.col_dg': 'DG',
  'comp.col_form': 'Forma',
  'comp.col_gc': 'GC',
  'comp.col_gf': 'GF',
  'comp.col_pe': 'PE',
  'comp.col_pg': 'PG',
  'comp.col_pj': 'PJ',
  'comp.col_pos': '#',
  'comp.col_pp': 'PP',
  'comp.col_pts': 'Pts',
  'comp.current_round': 'Jornada en curs:',
  'comp.final_score': 'Resultat Final',
  'comp.finished': 'FINALITZADA',
  'comp.form_col': 'Forma',
  'comp.goalscorers': 'Golejadors',
  'comp.group_id_prefix': 'ID de Grup: ',
  'comp.group_label': 'Grup',
  'comp.in_progress': 'EN JOC',
  'comp.league_desc': 'Lliga regular de 20 clubs · 38 jornades anada i tornada · 4 descensos directes.',
  'comp.legend_champions': 'Champions League',
  'comp.legend_conf': '7è Conference League',
  'comp.legend_conference': 'Conference League',
  'comp.legend_direct_promotion': 'Ascens directe',
  'comp.legend_europa': 'Europa League',
  'comp.legend_playoff': 'Playoff d\'ascens',
  'comp.legend_rel': '17-20è Descens Directe',
  'comp.legend_relegation': 'Descens',
  'comp.legend_ucl': '1-4è Champions League',
  'comp.legend_uel': '5-6è Europa League',
  'comp.live_standings': 'Classificació en Viu',
  'comp.loading_fixtures': 'Carregant partits de la jornada...',
  'comp.loading_round': 'Carregant jornada...',
  'comp.loading_standings': 'Carregant classificació del grup...',
  'comp.match_detail': 'Detall de Partit',
  'comp.match_detail_title': 'Detall del Partit',
  'comp.next_round': 'Jornada següent',
  'comp.no_fixtures': 'No hi ha partits programats per a aquesta jornada.',
  'comp.official_calendar': 'Calendari oficial',
  'comp.prev_round': 'Jornada anterior',
  'comp.refresh_standings': 'Actualitzar classificació en viu',
  'comp.round_header': 'Jornada {current} de {total}',
  'comp.round_of': 'de',
  'comp.round_prefix': 'Jornada',
  'comp.scorers': 'Golejadors',
  'comp.simulate_round': 'Simular Jornada {round}',
  'comp.spectators': 'Espectadors',
  'comp.standings_title': 'Classificació en Viu',
  'comp.status': 'Estat',
  'comp.subtitle': 'Lliga regular de 20 clubs · 38 jornades anada i tornada · 4 descensos directes.',
  'comp.ticket_revenue': 'Recaptació Taquilla',
  'comp.tiebreaker': 'Desempat: Pts · DG · GF',
  'comp.tiebreaker_legend': 'Desempat: Pts · DG · GF',
  'comp.title': 'Competició Oficial',
  'comp.you': 'TU',
  'comp.you_badge': 'TU',
  'dashboard.away': 'Visitant',
  'dashboard.away_badge': 'Rival a la Lliga',
  'dashboard.current_position': 'La teva posició actual: {pos}è classificat amb {pts} punts',
  'dashboard.edit_lineup': 'Modificar Alineació',
  'dashboard.forecast_attendance': 'Previsió d’Assistència',
  'dashboard.forecast_revenue': 'Ingressos Estimats',
  'dashboard.home': 'Local',
  'dashboard.kpi_budget': 'Pressupost per a Fitxatges',
  'dashboard.kpi_budget_sub': 'Fons disponibles sense comprometre',
  'dashboard.kpi_stadium': 'Aforament de l’Estadi',
  'dashboard.kpi_stadium_sub': 'Capacitat actual',
  'dashboard.kpi_staff': 'Nivell Cos Tècnic',
  'dashboard.kpi_staff_sub': 'Mitjana estrelles 4 preparadors',
  'dashboard.kpi_ticket': 'Preu Entrada General',
  'dashboard.kpi_ticket_sub': 'Fixat per a la temporada',
  'dashboard.lineup_incomplete': 'Alineació incompleta ({current}/11 seleccionats)',
  'dashboard.lineup_ready': 'Alineació completa i a punt',
  'dashboard.lineup_unavailable': 'No s’ha pogut consultar l’alineació',
  'dashboard.local_badge': 'El Teu Club',
  'dashboard.news_count_plural': 'notícies',
  'dashboard.news_count_single': 'notícia',
  'dashboard.news_desc': 'Últims moviments oficials, traspassos confirmats i actualitat del campionat',
  'dashboard.news_empty': 'No hi ha notícies o traspassos registrats en aquesta competició actualment.',
  'dashboard.news_live': 'En directe',
  'dashboard.news_loading': 'Carregant notícies i traspassos de la lliga...',
  'dashboard.news_title': 'Notícies i Fitxatges de la Lliga',
  'dashboard.news_today': 'AVUI',
  'dashboard.news_view_market': 'Veure Mercat',
  'dashboard.news_yesterday': 'AHIR',
  'dashboard.next_match': 'Proper Encontre (Jornada {round})',
  'dashboard.play_round': 'Disputar Jornada {round}',
  'dashboard.quick_finance_desc': 'Amplia grades, millora mòduls comercials, contracta preparadors i gestiona línies de crèdit.',
  'dashboard.quick_finance_title': 'Estadi i Finances',
  'dashboard.quick_market_desc': 'Fitxa agents lliures, executa clàusules de rescissió o posa en venda futbolistes transferibles.',
  'dashboard.quick_market_title': 'Mercat de Fitxatges',
  'dashboard.quick_squad_desc': 'Defineix la formació tàctica (4-3-3, 4-4-2, etc.), assigna dorsals i ajusta l’onze per al partit.',
  'dashboard.quick_squad_title': 'Plantilla i Onze Titular',
  'dashboard.retry': 'Reintentar',
  'dashboard.season_info': 'Temporada 2026/27 · Jornada {round} de {total}',
  'dashboard.see_results': 'Veure Resultats i Taula',
  'dashboard.stadium_label': 'Estadi',
  'dashboard.standings_full': 'Veure taula completa',
  'dashboard.standings_title': 'Classificació',
  'dashboard.starters_count': 'Onze Titular',
  'dashboard.status_closed': 'Tancada',
  'dashboard.status_label': 'Estat',
  'dashboard.status_locked': 'Bloquejada (Llista)',
  'dashboard.status_open': 'Oberta',
  'dashboard.status_scored': 'Disputada',
  'leagues.acronym_label': 'Acrònim (3 lletres)',
  'leagues.active_badge': 'Lliga Activa',
  'leagues.active_game': 'Partida en curs',
  'leagues.cancel': 'Cancel·lar',
  'leagues.club_name_in_league': 'Nom del teu Club en aquesta Lliga',
  'leagues.code_placeholder': 'Ex. PRIV-88219',
  'leagues.code_prefix': 'Codi',
  'leagues.create_action': 'Crear Lliga',
  'leagues.create_and_join': 'Crear Club i Unir-se',
  'leagues.create_btn': 'Crear Lliga Privada',
  'leagues.create_modal_title': 'Crear Nova Lliga Privada',
  'leagues.create_new_league': 'Crear Nova Lliga',
  'leagues.enter_club': 'Entrar al Club',
  'leagues.enter_club_placeholder': 'Introdueix el nom del teu club (ex. Burbia FC)',
  'leagues.enter_code': 'Introdueix el codi d’invitació:',
  'leagues.enter_league': 'Entrar a la Lliga',
  'leagues.error_title': 'Error en consultar competicions',
  'leagues.global_competition': 'Competició Global',
  'leagues.global_tab': 'Lligues Globals',
  'leagues.invite_code_label': 'Codi d\'Invitació (ex. PRIV-9872)',
  'leagues.join_action': 'Unir-me',
  'leagues.join_closed': 'INSCRIPCIÓ TANCADA',
  'leagues.join_code_btn': 'Unir-se amb Codi',
  'leagues.join_modal_title': 'Unir-se a Lliga Privada',
  'leagues.join_open': 'INSCRIPCIÓ OBERTA',
  'leagues.join_with_code': 'Unir-se amb Codi',
  'leagues.league_name': 'Nom de la Lliga',
  'leagues.league_name_label': 'Nom de la Lliga',
  'leagues.main_league': 'Lliga Principal',
  'leagues.managing_club': 'Estàs dirigint el',
  'leagues.members': 'mànagers',
  'leagues.my_competitions': 'Les Meves Competicions i Lligues Actives',
  'leagues.no_private': 'No tens lligues privades actives actualment. Crea’n una o uneix-te amb un codi!',
  'leagues.no_private_leagues': 'Encara no pertanys a cap lliga privada',
  'leagues.no_private_leagues_desc': 'Crea la teva pròpia lliga d\'amics per competir per jornada amb normes i fitxatges propis, o uneix-te amb el codi d\'invitació.',
  'leagues.not_available': 'No disponible',
  'leagues.official_badge': 'OFICIAL',
  'leagues.official_competition': 'Competició Oficial del Sistema',
  'leagues.official_desc': 'Inscriu-te a la competició global creant el teu club. Competiràs al sistema de divisions oficial amb ascensos, descensos i cicles competitius.',
  'leagues.participants_count': 'Nombre de Participants',
  'leagues.play_league': 'Jugar aquesta lliga',
  'leagues.primary_color': 'Color Principal',
  'leagues.private_disabled': 'Les lligues privades estan inhabilitades actualment en aquesta temporada.',
  'leagues.private_leagues': 'Lligues Privades amb Amics',
  'leagues.private_tab': 'Lligues Privades',
  'leagues.registering_club': 'Registrant club...',
  'leagues.registrations_not_open': 'Les inscripcions per a la competició global no estan obertes en aquest moment.',
  'leagues.resume_game': 'Continuar Partida (Dashboard)',
  'leagues.round_of': 'Jornada {current} de {total}',
  'leagues.selection_desc': 'Selecciona la lliga en què vols competir. Cada competició gestiona de manera aïllada el teu club, plantilla, economia, finances de l’estadi i resultats.',
  'leagues.subtitle': 'Tria la teva competició oficial o accedeix a una lliga privada amb els teus amics.',
  'leagues.teams': 'Equips',
  'leagues.title': 'Centre de Lligues i Competicions',
  'leagues.validate_and_enter': 'Validar Codi i Entrar',
  'leagues.your_club': 'El Teu Club',
  'loans.active': 'activa(es)',
  'loans.amount_label': 'Import del Préstec (M€)',
  'loans.desc': 'Sol·licita finançament fins a un màxim de 25 M€ a un tipus d’interès fix del 6% anual.',
  'loans.instalment': 'Quota per temporada',
  'loans.max_credit_capacity': 'Capacitat Màxima de Crèdit',
  'loans.request_btn': 'Sol·licitar Concessió Immediata',
  'loans.season_singular': 'Temporada',
  'loans.seasons_plural': 'Temporades',
  'loans.term_label': 'Termini d’Amortització (Temporades)',
  'loans.title': 'Línia de Crèdit Bancari',
  'loans.total_repay': 'Total a retornar (amb 6% int.)',
  'loans.year_suffix': 'any',
  'market.add_watchlist': 'Afegir a Cartera',
  'market.available_balance': 'Saldo Disponible Fitxatges',
  'market.badge': 'Mercat, Ofertes & Cartera',
  'market.balance': 'Saldo Disponible Fitxatges',
  'market.buyout': 'Clausulada',
  'market.daily_bidding': 'Licitació Diària',
  'market.closes_at': 'Tancament de licitació',
  'market.cancel': 'Cancel·lar',
  'market.cancel_offer': 'Cancel·lar Oferta',
  'market.club_balance': 'Saldo Club',
  'market.contract_years': 'Durada (Anys)',
  'market.desc': 'Negociació objectiva de contractes, estat d’ofertes actives i cartera de futbolistes en seguiment.',
  'market.empty_market': 'No s’han trobat futbolistes amb els filtres seleccionats.',
  'market.error_funds_reservation_rejected': 'Reserva de fons rebutjada. Saldo insuficient per presentar l’oferta.',
  'market.error_funds_reservation_rejected_details': 'Saldo insuficient per presentar l’oferta. Necessites {requestedAmount} i en tens {availableAmount} disponibles.',
  'market.error_insufficient_funds': 'Saldo insuficient per presentar l’oferta. Necessites {requestedAmount} i en tens {availableAmount} disponibles.',
  'market.eval_accept': 'El futbolista acceptarà aquesta proposta',
  'market.eval_reject': 'Proposta insuficient per al jugador',
  'market.filter_all': 'Tots',
  'market.filter_att': 'DAV',
  'market.filter_def': 'DEF',
  'market.filter_gk': 'POR',
  'market.filter_mid': 'MIG',
  'market.free_badge': 'Agent Lliure',
  'market.loading_agents': 'carregant...',
  'market.modal_edit_title': 'Modificar Oferta Activa per {name}',
  'market.modal_title': 'Proposta de Contracte a {name}',
  'market.negotiate': 'Negociar Contracte',
  'market.no_offers': 'No tens ofertes actives de traspàs en aquest moment.',
  'market.no_watchlist': 'La teva cartera de seguiment és buida. Marca futbolistes amb la icona de marcador per seguir-los.',
  'market.offered_clause': 'Nova Clàusula de Rescissió (M€)',
  'market.offered_salary': 'Fitxa Anual Proposada (M€)',
  'market.offers_all': 'Totes les Ofertes',
  'market.offers_market_targets': 'Objectius de Mercat',
  'market.offers_sent': 'Les Meves Ofertes Emeses',
  'market.only_free': 'Només Lliures',
  'market.remove_sale': 'Retirar de Transferibles',
  'market.remove_watchlist': 'Treure de Cartera',
  'market.required_funds': 'Cost Inicial Total',
  'market.search_placeholder': 'Cercar futbolista...',
  'market.signing_bonus': 'Prima de Fitxatge (M€)',
  'market.submit_offer': 'Formalitzar Oferta',
  'market.subtab_active_offers': 'Ofertes Actives',
  'market.subtab_history_offers': 'Historial d\'Ofertes',
  'market.history_title': 'Historial de Licitacions per Jugadors Lliures',
  'market.history_desc': 'Registre històric d\'ofertes presentades, resolucions de licitacions i ofertes guanyades o perdudes.',
  'market.history_filter_all': 'Totes les Ofertes',
  'market.history_filter_won': 'Guanyades',
  'market.history_filter_lost': 'Perdudes',
  'market.history_filter_cancelled': 'Cancel·lades',
  'market.history_won_badge': 'Fitxatge Guanyat',
  'market.history_lost_badge': 'Superada',
  'market.history_cancelled_badge': 'Oferta Cancel·lada',
  'market.rejection_reason_title': 'Motiu del rebuig',
  'market.rejection_reason_ACCEPTED_OTHER_CLUB': "Va acceptar l'oferta d'un altre club",
  'market.rejection_reason_RELEASE_CLAUSE_TOO_HIGH': 'Clàusula de rescissió massa alta',
  'market.rejection_reason_ECONOMIC_OFFER_TOO_LOW': 'Oferta econòmica insuficient',
  'market.history_empty': 'No s\'han trobat ofertes a l\'historial amb els criteris seleccionats.',
  'market.history_total_won': 'Fitxatges Guanyats',
  'market.history_total_lost': 'Ofertes Perdudes',
  'market.history_total_cancelled': 'Cancel·lades',
  'market.history_total_invested': 'Inversió Guanyada',
  'market.history_search_placeholder': 'Filtrar per nom de futbolista...',
  'market.subtab_market': 'Mercat',
  'market.subtab_my_sales': 'Els Meus Transferibles',
  'market.subtitle': 'Negociació objectiva de contractes i clàusules de rescissió amb control de fons.',
  'market.tab_market': 'Jugadors',
  'market.tab_offers': 'Ofertes',
  'market.tab_watchlist': 'Cartera',
  'market.title': 'Mercat de Fitxatges i Contractacions',
  'market.transfer_fee': 'Preu de Traspàs al Club (M€)',
  'market.transfer_offer': 'Oferta Formal',
  'market.update_offer': 'Desar Canvis',
  'match.away': 'Visitant',
  'match.badge': 'Simulació de Partits',
  'match.batch_notice': 'Gestió batch automatitzada al backend',
  'match.col_goals': 'Gols',
  'match.col_player': 'Futbolista',
  'match.col_points': 'Punts Fantasy',
  'match.col_pos': 'Pos',
  'match.col_reds': 'Vermelles',
  'match.col_stars': 'Estrelles Premsa (1-5★)',
  'match.col_yellows': 'Grogues',
  'match.cycle_title': 'Fases del Cicle de Jornada',
  'match.editorial_desc': 'Puntuacions oficials (1-5 estrelles) i esdeveniments per calcular els punts fantasy.',
  'match.editorial_title': 'Panell Editorial de Premsa Esportiva',
  'match.home': 'Local',
  'match.match_attendance': 'Assistència Registrada:',
  'match.match_goals': 'Gols del Partit:',
  'match.mod_attendance': 'Pressió Ambiental / Aforament Local',
  'match.mod_attendance_desc': 'Bonus per percentatge d’ocupació de l’estadi',
  'match.mod_momentum': 'Inèrcia Positiva (Momentum)',
  'match.mod_momentum_desc': 'Ràtxa de victòries en els últims 5 partits',
  'match.mod_staff': 'Preparació de Staff Tècnic',
  'match.mod_staff_desc': 'Mitjana d’estrelles del cos tècnic',
  'match.next_btn': 'Avançar a la Següent Jornada',
  'match.not_sent_off': 'No',
  'match.phase1_desc': 'Alineació Oberta',
  'match.phase2_desc': 'XI Congelat',
  'match.phase3_desc': 'Punts Calculats',
  'match.phase4_desc': 'Jornada Tancada',
  'match.publish_btn': 'Publicar Qualificacions Oficials',
  'match.sent_off': 'Expulsat',
  'match.simulate_btn': 'Calcular i Simular Jornada {round}',
  'match.subtitle': 'Cicle de jornada: PLANNED → OPEN → LOCKED → SCORED → CLOSED. Rendiment esportiu.',
  'match.tab_editorial': 'Qualificacions de Premsa',
  'match.tab_engine': 'Modificadors de Rendiment',
  'match.tactical_desc': 'Càlcul de factors multiplicadors aplicats pel motor de simulació.',
  'match.tactical_title': 'Modificadors Tàctics i de Rendiment',
  'match.ticket_revenue': 'Recaptació de Taquilla:',
  'match.title': 'Centre de Jornada & Match Engine',
  'match.user_fixture_title': 'Encontre del Teu Club a Jornada {round}',
  'matches.away_label': 'Visitant',
  'matches.batch_info': 'Gestió batch automatitzada al backend',
  'matches.col_fantasy_pts': 'Punts Fantasy',
  'matches.col_goals': 'Gols',
  'matches.col_player': 'Futbolista',
  'matches.col_pos': 'Pos',
  'matches.col_press_stars': 'Estrelles Premsa (1-5★)',
  'matches.col_reds': 'Vermelles',
  'matches.col_yellows': 'Grogues',
  'matches.desc': 'Cicle de jornada: PLANNED → OPEN → LOCKED → SCORED → CLOSED. Backoffice de rendiment esportiu i puntuacions.',
  'matches.editorial_desc': 'Puntuacions oficials (1-5 estrelles) i esdeveniments per calcular els punts fantasy de la jornada.',
  'matches.editorial_title': 'Panell Editorial de Premsa Esportiva',
  'matches.home_label': 'Local',
  'matches.lineup_frozen': 'XI Congelat',
  'matches.lineup_open': 'Alineació Oberta',
  'matches.match_goals': 'Gols del Partit',
  'matches.mod_attendance': 'Pressió Ambiental / Aforament Local',
  'matches.mod_attendance_desc': 'Bonificació per percentatge d’ocupació de l’estadi',
  'matches.mod_momentum': 'Inèrcia Positiva (Momentum)',
  'matches.mod_momentum_desc': 'Ratxa de victòries en els darrers 5 partits',
  'matches.mod_staff': 'Preparació del Cos Tècnic',
  'matches.mod_staff_desc': 'Mitjana d’estrelles del cos tècnic',
  'matches.not_sent_off': 'No',
  'matches.performance_mods': 'Modificadors de Rendiment',
  'matches.phase': 'Fase',
  'matches.phases_title': 'Fases del Cicle de Jornada',
  'matches.points_calculated': 'Punts Calculats',
  'matches.press_ratings': 'Qualificacions de Premsa',
  'matches.publish_ratings': 'Publicar Qualificacions Oficials',
  'matches.recorded_attendance': 'Assistència Registrada',
  'matches.round_closed': 'Jornada Tancada',
  'matches.sent_off': 'Expulsat',
  'matches.simulation_badge': 'Simulació de Partits',
  'matches.spectators_suffix': 'espectadors',
  'matches.tactical_mods_desc': 'Càlcul de factors multiplicadors aplicats pel motor de simulació per al proper matx.',
  'matches.tactical_mods_title': 'Modificadors Tàctics i de Rendiment',
  'matches.ticket_collection': 'Recaptació de Taquilla',
  'matches.title': 'Centre de Jornada & Match Engine',
  'matches.user_fixture_title': 'Partit del Teu Club a la Jornada',
  'nav.all_leagues': 'Veure totes / Unir-se a una altra lliga...',
  'nav.api': 'API',
  'nav.budget': 'Pressupost',
  'nav.club': 'Club',
  'nav.news': 'Notícies',
  'nav.competition': 'Competició',
  'nav.competition_context': 'Context de Competició',
  'nav.credits': 'Crèdits (CR)',
  'nav.dark_mode_enabled': 'Mode Fosc activat',
  'nav.dark_mode_title': 'Mode Fosc / Clar',
  'nav.dashboard': 'Dashboard',
  'nav.language': 'Idioma',
  'nav.light_mode_enabled': 'Mode Clar activat',
  'nav.logout': 'Tancar Sessió',
  'nav.market': 'Mercat',
  'nav.matchengine': 'Jornada',
  'nav.next_matchday': 'Avançar a J{round}',
  'nav.settings': 'Ajustos',
  'nav.simulate': 'Simular J{round}',
  'nav.squad': 'Plantilla',
  'nav.stadium': 'Club',
  'nav.switch_league': 'Canviar de lliga',
  'nav.toggle_theme_dark': 'Mode Fosc',
  'nav.toggle_theme_light': 'Mode Clar',
  'settings.lang_desc': 'Disponible en els 4 idiomes oficials (Español, Català, Galego i Euskara).',
  'settings.lang_title': 'Seleccionar Idioma de la Plataforma',
  'settings.notifications_desc': 'Visualitzar avisos informatius i d’èxit (si es desactiva, només es mostraran errors).',
  'settings.notifications_disabled': 'Només Errors',
  'settings.notifications_enabled': 'Activades',
  'settings.notifications_title': 'Notificacions del Sistema',
  'settings.profile_club': 'Club Actual Assignat',
  'settings.profile_desc': 'Dades del compte d’usuari i credencials d’accés.',
  'settings.profile_email': 'Correu de Contacte',
  'settings.profile_info': 'Informació del Mànager',
  'settings.profile_logout': 'Tancar Sessió Oficial',
  'settings.profile_name': 'Nom Oficial',
  'settings.profile_role': 'Rol al Sistema',
  'settings.profile_version': 'Versió de la Plataforma',
  'settings.separation_desc': 'La tresoreria del club està completament desvinculada dels crèdits d’usuari. El teu Wallet personal de crèdits (CR) s’administra de forma independent a Ajustos.',
  'settings.separation_title': 'Separació de Fons',
  'settings.subtitle': 'Configuració, preferències i Wallet de crèdits personals',
  'settings.tab_preferences': 'Preferències',
  'settings.tab_profile': 'Perfil',
  'settings.tab_wallet': 'Wallet (CR)',
  'settings.theme_dark': 'Mode Fosc (Nit)',
  'settings.theme_desc': 'Canvia entre el mode clar i el mode fosc optimitzat per a baixa lluminositat.',
  'settings.theme_light': 'Mode Clar (Dia)',
  'settings.theme_title': 'Tema Visual de l’Aplicació',
  'settings.title': 'Ajustos del Mànager',
  'settings.wallet_balance': 'Saldo al Wallet',
  'settings.wallet_benefit_analytics': 'Mòduls analítics avançats',
  'settings.wallet_benefit_fee': 'Llicència federativa mensual',
  'settings.wallet_benefit_leagues': 'Lligues VIP entre mànagers',
  'settings.wallet_best_value': 'Millor Valor',
  'settings.wallet_desc': 'Crèdits personals de mànager independents de la tresoreria del club.',
  'settings.wallet_explanation': 'Els crèdits (CR) pertanyen al teu compte personal i no es barregen amb els fons ni el pressupost del club.',
  'settings.wallet_monthly_fee': 'Quota mensual de llicència',
  'settings.wallet_open': 'Gestionar Wallet',
  'settings.wallet_pay_fee': 'Abonar Quota Mensual (-100 CR)',
  'settings.wallet_personal_funds': 'Fons Personals',
  'settings.wallet_popular': 'Popular',
  'settings.wallet_recharge': 'Recarregar Crèdits',
  'settings.wallet_recharge_btn': 'Recarregar {cr} CR',
  'settings.wallet_recharge_instant': 'Recàrrega immediata al moneder',
  'settings.wallet_title': 'Wallet del Mànager (CR)',
  'squad.age': 'anys',
  'squad.auto_pick': 'Auto Onze',
  'squad.badge_management': 'Gestió d’Onze',
  'squad.cancel': 'Cancel·lar',
  'squad.clause': 'Clàusula',
  'squad.col_actions': 'Accions',
  'squad.col_age': 'Edat',
  'squad.col_clause': 'Clàusula',
  'squad.col_number': '#',
  'squad.col_ovr': 'OVR',
  'squad.col_player': 'Futbolista',
  'squad.col_pos': 'Pos',
  'squad.col_salary': 'Fitxa',
  'squad.col_status': 'Estat',
  'squad.confirm_renew': 'Confirmar Renovació',
  'squad.desc': 'Exactament 11 titulars per a la Jornada. Sense substitucions en directe.',
  'squad.formation': 'Formació',
  'squad.lock_xi': 'Bloquejar XI',
  'squad.locked_xi': 'XI Bloquejat',
  'squad.new_clause': 'Nova Clàusula (M€)',
  'squad.new_salary': 'Nova Fitxa Anual (M€)',
  'squad.new_years': 'Anys de Contracte',
  'squad.ovr': 'Mitjana OVR',
  'squad.pos_def': 'Defensa',
  'squad.pos_del': 'Davanter',
  'squad.pos_df': 'DEF',
  'squad.pos_fw': 'DAV',
  'squad.pos_gk': 'POR',
  'squad.pos_med': 'Migcampista',
  'squad.pos_mf': 'MIG',
  'squad.pos_por': 'Porter',
  'squad.put_transferable': 'Posa en venda',
  'squad.remove_transferable': 'Retirar de venda',
  'squad.renew_contract': 'Renovar Contracte',
  'squad.renew_modal_title': 'Renovació de Contracte',
  'squad.salary': 'Fitxa Anual',
  'squad.save_lineup': 'Desar',
  'squad.saved': 'Desat',
  'squad.saving': 'Desant...',
  'squad.starters_count': 'Titulars',
  'squad.starting_xi': 'Onze Titular ({count}/11)',
  'squad.substitutes': 'Banqueta i Reserves ({count})',
  'squad.subtitle': 'Configura la teva tàctica, formació i alineació per a la propera jornada.',
  'squad.tactical_board': 'Formació',
  'squad.title': 'Plantilla i Tàctica',
  'squad.transfer_status': 'Estat',
  'squad.transferable': 'Transferible',
  'squad.years': 'anys',
  'stadium.attendance_sim_note': 'Estimació segons el preu i les instal·lacions actuals, amb classificació neutral. Els ingressos comercials fan servir tarifes orientatives; el resultat real pot variar.',
  'stadium.attendance_sim_title': 'Simulació d’Aforament Previst',
  'stadium.badge': 'Infraestructura & Finances',
  'stadium.cafeteria_desc': 'Augmenta les vendes de menjar i beguda durant els descansos.',
  'stadium.cafeteria_title': 'Cafeteries & Restauració',
  'stadium.capacity_desc': 'Augmenta la capacitat de l’estadi per generar majors ingressos a taquilla.',
  'stadium.capacity_label': 'Aforament',
  'stadium.capacity_title': 'Ampliació de Grades i Aforament',
  'stadium.capacity_upgrade_title': 'Ampliació de Graderies i Aforament',
  'stadium.commercial_modules_title': 'Mòduls Comercials i Explotació',
  'stadium.confirm_pricing': 'Confirmar Preus per al Proper Partit',
  'stadium.confirm_tickets': 'Confirmar Preus per al Proper Partit',
  'stadium.current': 'Actual',
  'stadium.current_tier': 'Aforament Vigent',
  'stadium.desc': 'Preus, aforament, mòduls comercials, cos tècnic, crèdits bancaris i llibre major (Ledger).',
  'stadium.economy_tier': 'Econòmic',
  'stadium.est_attendance': 'Ocupació Estimada:',
  'stadium.expense': 'DESPESA',
  'stadium.general_ticket': 'Preu Entrada General',
  'stadium.general_ticket_price': 'Preu Entrada General',
  'stadium.income': 'INGRÉS',
  'stadium.ledger_amount': 'Import',
  'stadium.ledger_balance': 'Saldo Resultant',
  'stadium.ledger_concept': 'Concepte',
  'stadium.ledger_date': 'Data',
  'stadium.ledger_desc': 'Registre comptable',
  'stadium.ledger_entries': '{count} apunts registrats',
  'stadium.ledger_title': 'Transaccions',
  'stadium.ledger_type': 'Tipus',
  'stadium.level': 'Nivell',
  'stadium.loan_amount': 'Import del Préstec (M€)',
  'stadium.loan_apply': 'Sol·licitar Concessió Immediata',
  'stadium.loan_desc': 'Sol·licita finançament fins a un màxim de 25 M€ a un tipus d’interès fix del 6% anual.',
  'stadium.loan_installment': 'Quota per temporada:',
  'stadium.loan_title': 'Línia de Crèdit Bancari',
  'stadium.loan_total': 'Total a retornar (amb 6% int.):',
  'stadium.loan_years': 'Termini d’Amortització (Temporades)',
  'stadium.max_level': 'Nivell Màxim',
  'stadium.merchandising_desc': 'Venda de samarretes i bufandes oficials en dies de partit.',
  'stadium.merchandising_title': 'Botigues Oficials',
  'stadium.mod_cafeteria': 'Cafeteries & Restauració',
  'stadium.mod_level': 'Nivell {level}/5',
  'stadium.mod_max': 'Nivell Màxim',
  'stadium.mod_merch': 'Botigues Oficials',
  'stadium.mod_parking': 'Pàrquing Estadi',
  'stadium.modules_desc': 'Millora les instal·lacions comercials per incrementar els ingressos per aficionat a cada partit.',
  'stadium.modules_title': 'Mòduls Comercials i Explotació',
  'stadium.parking_desc': 'Millora l’ingrés per seient i la comoditat dels aficionats.',
  'stadium.parking_title': 'Pàrquing Estadi',
  'stadium.passed_tier': 'Superat',
  'stadium.premium_tier': 'Prèmium',
  'stadium.pricing_desc': 'Ajusta el preu mitjà de les entrades generals per optimitzar la taquilla segons la demanda i la forma de l’equip.',
  'stadium.pricing_title': 'Fixació de Preus d’Entrades',
  'stadium.proj_commercial': 'Ingressos Comercials (Pàrquing/Bar):',
  'stadium.proj_tickets': 'Ingressos Taquilla Projectats:',
  'stadium.projected_commercial': 'Ingressos Comercials (Pàrquing/Bar)',
  'stadium.projected_tickets': 'Ingressos Taquilla Projectats',
  'stadium.reserved_funds': 'Fons Reservat',
  'stadium.seats': 'Seients',
  'stadium.sim_title': 'Simulació d’Aforament Previst',
  'stadium.staff_desc': 'Cada àrea de preparació incrementa el rendiment de l’equip en el motor de partit.',
  'stadium.staff_fitness': 'Entrenador de Defenses',
  'stadium.staff_gk': 'Entrenador Porters',
  'stadium.staff_shooting': 'Entrenador de Davanters',
  'stadium.staff_tech': 'Entrenador de Migcampistes',
  'stadium.staff_title': 'Cos Tècnic i Preparadors',
  'stadium.staff_upgrade': '+0.5★ (0.5 M€)',
  'stadium.standard_tier': 'Estàndard',
  'stadium.stands_level': 'Graderies Nivell',
  'stadium.sub_balance': 'Saldo Actual de Crèdits:',
  'stadium.sub_cost': 'Cost Quota Mensual:',
  'stadium.sub_desc': 'Gestió de quota mensual i crèdits per a partides i simulacions avançades.',
  'stadium.sub_pay': 'Abonar Quota Mensual (-100 CR)',
  'stadium.sub_title': 'Subscripció i Crèdits (CR)',
  'stadium.subtitle': 'Preus, aforament, mòduls comercials, cos tècnic, crèdits bancaris i llibre major.',
  'stadium.surpassed_tier': 'Superat',
  'stadium.sync_server': 'Sincronitzar dades amb el servidor',
  'stadium.tab_economy': 'Economia',
  'stadium.tab_stadium': 'Estadi',
  'stadium.tab_staff': 'Staff',
  'stadium.ticket_desc': 'Ajusta el preu mitjà de les entrades generals per optimitzar la taquilla segons la demanda i la forma de l’equip.',
  'stadium.ticket_title': 'Fixació de Preus d’Entrades',
  'stadium.title': 'Estadi i Infraestructura Financera',
  'stadium.total_capacity': 'Aforament Total de l’Estadi:',
  'stadium.treasury': 'Tresoreria Club (EUR)',
  'stadium.upgrade_btn': 'Ampliar',
  'stadium.upgrade_level_btn': 'Millorar Nivell',
  'stadium.upgrade_module': 'Millorar Nivell ({cost} M€)',
  'staff.annual_cost': 'Cost Anual',
  'staff.desc': 'Staff tècnic oficial i preparadors especialitzats que potencien el rendiment competitiu del club.',
  'staff.fitness_coach': 'Entrenador de Defenses',
  'staff.goalkeeping_coach': 'Entrenador de Porters',
  'staff.modifier': 'Modificador',
  'staff.on_payroll': 'preparadors en nòmina',
  'staff.quality_level': 'Nivell / Qualitat',
  'staff.shooting_coach': 'Entrenador de Davanters',
  'staff.tactical_coach': 'Entrenador de Migcampistes',
  'staff.title': 'Cos Tècnic i Preparadors',

  // Coaches (Entrenadors)
  'coaches.title': 'Entrenadors',
  'coaches.tab_market': 'Mercat d’Entrenadors',
  'coaches.tab_my_coach': 'El Meu Entrenador',
  'coaches.tab_offers': 'Ofertes Presentades',
  'coaches.daily_market': 'Mercat Diari d’Entrenadors',
  'coaches.daily_market_desc': 'Tècnics lliures disponibles avui per licitar i sumar bonificacions a les línies de l’equip.',
  'coaches.closes_at': 'Tancament de licitació',
  'coaches.time_left': 'Temps restant',
  'coaches.closed': 'Mercat Tancat (processant adjudicació)',
  'coaches.empty_market': 'No hi ha entrenadors disponibles al mercat avui',
  'coaches.empty_market_desc': 'El mercat no disposa de més tècnics lliures per a aquesta jornada. La selecció es renovarà a la propera data.',
  'coaches.attack': 'Atac',
  'coaches.midfield': 'Migcamp',
  'coaches.defense': 'Defensa',
  'coaches.bonus_sum_info': 'Les millores tàctiques sumen exactament un 15% entre les tres línies de l’equip.',
  'coaches.submit_offer': 'Presentar Oferta',
  'coaches.modify_offer': 'Modificar Oferta',
  'coaches.cancel_offer': 'Cancel·lar Oferta',
  'coaches.has_pending_offer': 'Tens una oferta activa per aquest tècnic',
  'coaches.offer_modal_title': 'Ofertar per Entrenador',
  'coaches.signing_bonus': 'Prima de Fitxatge (€)',
  'coaches.annual_salary': 'Salari de Temporada (€)',
  'coaches.release_clause': 'Clàusula de Rescissió (€)',
  'coaches.score': 'Puntuació d’Oferta',
  'coaches.score_formula': 'Puntuació = Prima × 60% + Salari × 40%',
  'coaches.score_explanation': 'Guanya la puntuació més alta entre els clubs licitadors. En empat exacte, preval la primera rebuda. La clàusula no intervé.',
  'coaches.disclaimer_bonus': 'La prima es cobrarà en adjudicar el fitxatge; enviar l’oferta no reserva saldo ni garanteix la contractació.',
  'coaches.disclaimer_salary': 'El salari es cobrarà prorratejat entre les jornades restants de la temporada al tancament de cadascuna.',
  'coaches.disclaimer_replacement': 'Avís de substitució: si guanyes la licitació i ja tens entrenador, el seu contracte quedarà rescindit i indemnitzaràs les jornades pendents.',
  'coaches.disclaimer_multiple': 'Només pots tenir una oferta d’entrenador activa per club i lliga. Per canviar-la, cancel·la-la abans del tancament i presenta’n una altra; perdràs la prioritat d’arribada original.',
  'coaches.offers_unverified': 'No pots licitar fins que es verifiquin les teves ofertes.',
  'coaches.retry': 'Torna-ho a provar',
  'coaches.checking_offers': 'Comprovant ofertes actives…',
  'coaches.uncertain_offer': 'No s’ha pogut confirmar l’enviament. Torna a enviar la mateixa oferta amb els mateixos imports abans de presentar-ne una altra.',
  'coaches.active_offer': 'Ja tens una oferta activa',
  'coaches.awaiting_resolution': 'Pendent de resolució: no pots cancel·lar ni presentar cap altra oferta fins que es resolgui.',
  'coaches.cancel_before_new': 'Per canviar d’entrenador o modificar els imports, cancel·la primer aquesta oferta abans del tancament.',
  'coaches.view_offer': 'Veure oferta activa',
  'coaches.status_pending': 'Pendent',
  'coaches.status_won': 'Adjudicada',
  'coaches.status_lost': 'No adjudicada',
  'coaches.status_insufficient_funds': 'Saldo insuficient',
  'coaches.status_cancelled': 'Cancel·lada',
  'coaches.active_coach': 'Entrenador del Club',
  'coaches.active_coach_desc': 'Condicions contractuals i bonificacions tàctiques aplicades al teu equip.',
  'coaches.no_active_coach': 'Sense entrenador contractat',
  'coaches.no_active_coach_desc': 'El club no compta amb entrenador actiu. Les línies de l’equip rendeixen amb millora neutral (+0%).',
  'coaches.contract_history': 'Historial de Contractes',
  'coaches.contract_active': 'Vigent',
  'coaches.contract_terminated': 'Rescindit',
  'coaches.contract_expired': 'Vençut',
  'coaches.go_to_market': 'Fitxar al Mercat d’Entrenadors',
  'coaches.ledger_signing_bonus': 'Prima de fitxatge d’entrenador',
  'coaches.ledger_termination': 'Indemnització per acomiadament d’entrenador',
  'coaches.ledger_salary': 'Salari d’entrenador',
  'coaches.match_frozen_notice': 'L’entrenador queda congelat a l’inici de la jornada. Una contractació posterior no altera el partit en curs.',
  'coaches.match_included_notice': 'Les potències calculades pel motor ja incorporen la millora d’aquest entrenador.',
};
